"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInstallmentsByProductStep = void 0;

var _react = _interopRequireDefault(require("react"));

var _ModalBody = require("../ModalBody");

var _EditCreditSection = require("../EditCreditSection.experimental");

var _constants = require("../../constants");

var _ProductInstallments = require("./ProductInstallments/ProductInstallments");

var _ProductInstallmentsStep = require("./ProductInstallmentsStep.style");

var _useProductInstallmentsStep = require("./useProductInstallmentsStep");

var _core = require("@emotion/core");

const ProductInstallmentsByProductStep = () => {
  const {
    intendedCredit,
    setIntendedCredit,
    productType,
    closeSimulator,
    onRequestProposalClick
  } = (0, _useProductInstallmentsStep.useProductInstallmentsStep)();
  return (0, _core.jsx)(_react.default.Fragment, null, (0, _core.jsx)(_ProductInstallmentsStep.ModalHeader, {
    onClose: closeSimulator
  }, (0, _core.jsx)(_EditCreditSection.EditCreditSection, {
    value: intendedCredit,
    productType: productType,
    onChange: setIntendedCredit
  })), (0, _core.jsx)(_ModalBody.ModalBody, {
    "data-testid": "product-installments-step-content"
  }, (0, _core.jsx)(_ProductInstallments.ProductInstallments, {
    productType: productType,
    selectedBy: _constants.ProductInstallmentsOrderBy[productType],
    "data-testid": `product-${productType}`,
    intendedCredit: intendedCredit,
    onRequestProposalClick: () => onRequestProposalClick(productType)
  })));
};

exports.ProductInstallmentsByProductStep = ProductInstallmentsByProductStep;
ProductInstallmentsByProductStep.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ProductInstallmentsByProductStep"
};